import React, { Component } from 'react';
import { Checkbox } from "@blueprintjs/core";

import TextInput from '../common/text-input';

class UserChangePasswordDialog extends Component {

    render() {
        const {
            onChangeInput,
            fullName,
            newPassword,
            verifyPassword,
            sendEmail,
            validPassword,
            passwordMatches
        } = this.props;

        return (
            <div>
                <h4 style={{ color: 'black' }} >Usuario</h4>
                <div className="row modal-row">
                    <div className="col">
                        <span style={{ fontSize: '0.9rem' }} >{fullName}</span>
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <TextInput
                            type={'password'}
                            value={newPassword}
                            onChange={(event) => onChangeInput('newPassword', event.target.value)}
                            labelText={'Contraseña *'}
                            helpText={validPassword ? 'Al menos 6 caracteres' : null}
                            errorText={!validPassword ? 'Contraseña demasiado corta' : null}
                        />
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <TextInput
                            type={'password'}
                            value={verifyPassword}
                            onChange={(event) => onChangeInput('verifyPassword', event.target.value)}
                            labelText={'Vuelve a introducir la contraseña *'}
                            helpText={passwordMatches ? 'Las contraseñas coinciden' : null}
                            errorText={!passwordMatches ? 'Las contraseñas no coinciden' : null}
                        />
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <div>
                            <Checkbox
                                checked={sendEmail}
                                onChange={(event) => onChangeInput('sendEmail', event.target.checked)}
                                label="Enviar email al usuario"
                                inline={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default UserChangePasswordDialog;




// WEBPACK FOOTER //
// ./src/components/dialogs/UserChangePasswordDialog.js